import colors, { type ColorTypes } from '@/styles/colors/color';

const useColor = (): ColorTypes => {
  const colorTheme = useColorTheme();
  return colorTheme === 'dark' ? colors : colors;
};

const useColorTheme = (): ColorTheme => {
  // const colorMode = useUIStore((state) => state.colorMode);
  // const systemTheme = useUIStore((state) => state.systemTheme);

  // return colorMode === 'system' ? systemTheme : colorMode;
  return 'light';
};

export default useColor;
export { useColorTheme };
